import React from 'react'

export default function LockImg() {
  return (
    <div>
      <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 8.99023H3C1.89543 8.99023 1 9.88566 1 10.9902V16.9902C1 18.0948 1.89543 18.9902 3 18.9902H13C14.1046 18.9902 15 18.0948 15 16.9902V10.9902C15 9.88566 14.1046 8.99023 13 8.99023Z" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M8 14.9902C8.55228 14.9902 9 14.5425 9 13.9902C9 13.4379 8.55228 12.9902 8 12.9902C7.44772 12.9902 7 13.4379 7 13.9902C7 14.5425 7.44772 14.9902 8 14.9902Z" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M4 8.99023V4.99023C4 3.92937 4.42143 2.91195 5.17157 2.16181C5.92172 1.41166 6.93913 0.990234 8 0.990234C9.06087 0.990234 10.0783 1.41166 10.8284 2.16181C11.5786 2.91195 12 3.92937 12 4.99023V8.99023" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

    </div>
  )
}
